import { TargetingType } from '../../config'
import React from 'react'
import { BaseBadge } from './BaseBadge'
import Campaign = Models.Campaign
import { ClassValue } from 'classnames/types'

const targetingTypeOptions = {
    [TargetingType.Manual]: { text: 'Manual', intent: 'primary' },
    [TargetingType.Auto]: { text: 'Auto', intent: 'warning' },
}

interface TargetingTypeBadgeProps {
    campaign?: Campaign | null
    targeting_type?: 1 | 2 | null
    className?: ClassValue
    suffix?: string
}

export const TargetingTypeBadge = ({
    campaign = null,
    targeting_type = null,
    className = '',
    suffix,
}: TargetingTypeBadgeProps) => {
    const value = targeting_type ?? campaign?.targeting_type
    return (
        <BaseBadge
            options={targetingTypeOptions}
            value={value}
            className={className}
            suffix={suffix}
        />
    )
}
